import { Modal } from 'antd'

import {
    findUnlinkedGiftCardsByPhones,
    linkGiftCardsToCustomer,
} from '../network/GiftCards'

export const collectPhonesFromCustomer = (customer) => {
    if (!customer || typeof customer !== 'object') {
        return []
    }

    const phones = new Set()

    if (customer.phone) {
        phones.add(String(customer.phone).trim())
    }

    if (customer.addresses?.length) {
        for (const address of customer.addresses) {
            if (address?.phone) {
                phones.add(String(address.phone).trim())
            }
        }
    }

    if (customer.contacts?.length) {
        for (const contact of customer.contacts) {
            if (contact?.phone) {
                phones.add(String(contact.phone).trim())
            }
        }
    }

    return [...phones].filter(Boolean)
}

const formatGiftCardLabel = (giftCard) => {
    const id = giftCard.giftCardID || giftCard.id

    if (giftCard.amount != null) {
        return `${id} (¥${giftCard.amount})`
    }

    return id
}

export const promptLinkGiftCardsToCustomer = async ({ customer, token, t }) => {
    const customerId = customer?.id || customer?._id

    if (!customerId) {
        return
    }

    const phones = collectPhonesFromCustomer(customer)

    if (!phones.length) {
        return
    }

    const giftCards = await findUnlinkedGiftCardsByPhones(phones, token)

    if (!giftCards.length) {
        return
    }

    const labels = giftCards.map(formatGiftCardLabel).join(', ')

    return new Promise((resolve) => {
        Modal.confirm({
            title: t('CUSTOMERS_PHONE_MATCHING_GIFT_CARDS_TITLE'),
            content: t('CUSTOMERS_PHONE_MATCHING_GIFT_CARDS_MESSAGE', {
                count: giftCards.length,
                ids: labels,
            }),
            okText: t('CUSTOMERS_PHONE_LINK_GIFT_CARDS'),
            cancelText: t('CANCEL'),
            onOk: async () => {
                await linkGiftCardsToCustomer(
                    customerId,
                    giftCards.map((giftCard) => giftCard.id),
                    token
                )
                resolve()
            },
            onCancel: () => {
                resolve()
            },
        })
    })
}
